import DemandMessageModel      from 'models/DemandMessageModel';
import React                   from 'react';
import { Form }                from 'antd';
import { Col }                 from 'antd';
import Row                     from 'components/App/Row';
import { DatePicker }          from 'antd';
import { TimePicker }          from 'antd';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import handleFormError         from 'utils/handleFormError';
import { REFUSED }             from 'constants/DemandStatuses';
import DemandModel             from 'models/DemandModel';
import DemandLogisticModel     from 'models/DemandLogisticModel';
import { ApiCollection }       from 'collections/ApiCollection';
import type { RefObject }      from 'react';
import type { FormInstance }   from 'antd';
import RichTextEditor          from 'components/App/RichTextEditor';
import { AppFormComponent }    from 'components/App/AppForm';
import MessageModel            from 'models/MessageModel';

interface RefuseDemandFormProps {
  demand: DemandModel;
  demandLogistic?: DemandLogisticModel;
  demandStatusCollection: ApiCollection;
  message: MessageModel;
  model: DemandMessageModel;
  onSuccess?: (model: DemandMessageModel) => void;
}

class RefuseDemandForm extends AppFormComponent<RefuseDemandFormProps> {
  public formRef: RefObject<FormInstance> = React.createRef();

  public componentDidMount() {
    const { demand, demandLogistic, message } = this.props;

    this.formRef.current?.setFieldsValue({
      askedDate: demand.askedDatetimeDate,
      askedTime: demand.askedDatetimeDate,
      content: message.get('content'),
      pickupDate: demandLogistic ? demandLogistic.pickupDatetimeDate : undefined,
      pickupTime: demandLogistic ? demandLogistic.pickupDatetimeDate : undefined,
    });
  }

  public render() {
    const { demandLogistic } = this.props;

    return (
      <Form ref={this.formRef}>
        <Row>
          <Col md={8} sm={24}>
            <Form.Item
              // help={getFieldError('askedDate') || ''}
              // validateStatus={getFieldError('askedDate') ? 'error' : ''}
              label={
                demandLogistic && demandLogistic.id ? (
                  <FormattedMessageWrapper id="Date de livraison validée" />
                ) : (
                  <FormattedMessageWrapper id="Date validée" />
                )
              }
              labelCol={{ span: 24 }}
              name="askedDate"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <DatePicker disabled format="DD/MM/YYYY" style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col md={6} sm={24}>
            <Form.Item
              // help={getFieldError('askedTime') || ''}
              // validateStatus={getFieldError('askedTime') ? 'error' : ''}
              label={
                demandLogistic && demandLogistic.id ? (
                  <FormattedMessageWrapper id="Heure de livraison validée" />
                ) : (
                  <FormattedMessageWrapper id="Heure validée" />
                )
              }
              labelCol={{ span: 24 }}
              name="askedTime"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <TimePicker disabled format="HH[h]mm" style={{ width: '100%' }} />
            </Form.Item>
          </Col>
        </Row>

        <div
          style={{
            display: demandLogistic && demandLogistic.id ? 'block' : 'none',
          }}
        >
          <Row>
            <Col md={8} sm={24}>
              <Form.Item
                // help={getFieldError('pickupDate') || ''}
                // validateStatus={getFieldError('pickupDate') ? 'error' : ''}
                label={<FormattedMessageWrapper id="Date d'enlèvement validée" />}
                labelCol={{ span: 24 }}
                name="pickupDate"
                rules={
                  demandLogistic && demandLogistic.id
                    ? [
                      {
                        message: <FormattedMessageWrapper id="Information manquante" />,
                        required: true,
                      },
                    ]
                    : []
                }
              >
                <DatePicker disabled format="DD/MM/YYYY" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col md={8} sm={24}>
              <Form.Item
                // help={getFieldError('pickupTime') || ''}
                // validateStatus={getFieldError('pickupTime') ? 'error' : ''}
                label={<FormattedMessageWrapper id="Heure d'enlèvement validée" />}
                labelCol={{ span: 24 }}
                name="pickupTime"
                rules={
                  demandLogistic && demandLogistic.id
                    ? [
                      {
                        message: <FormattedMessageWrapper id="Information manquante" />,
                        required: true,
                      },
                    ]
                    : []
                }
              >
                <TimePicker disabled format="HH[h]mm" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>
        </div>

        <Row>
          <Col span={24}>
            <Form.Item
              // help={getFieldError('content') || ''}
              // validateStatus={getFieldError('content') ? 'error' : ''}
              label={<FormattedMessageWrapper id="Message" />}
              labelCol={{ span: 24 }}
              name="content"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Contenu manquant" />,
                  required: true,
                },
              ]}
            >
              <RichTextEditor style={{ height: 150, marginBottom: 32 }} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }

  public submit = async () => {
    const {
      demand,
      demandStatusCollection,
      message,
      model,
      onSuccess,
    } = this.props;

    try {
      const values = await this.formRef.current?.validateFields();

      const demandStatusRefused = demandStatusCollection.find(
        ds => ds.get('reference') === REFUSED,
      );

      await message.patch({
        content: values.content,
      });

      await model.patch({
        demand: demand.iri,
        message: message.iri,
        newDemandStatus: demandStatusRefused?.get('@id'),
      });

      if (onSuccess) {
        onSuccess(model);
      }
    } catch (error) {
      handleFormError(error, this.formRef.current);
    }
  };
}

export default RefuseDemandForm;
